
import Request from "../constants/Request.api"
import Api from "../Api"

class CompanyService extends Api {
  constructor(user) {
    super()
    this.user = user
  }
  getStrategy = type => {
    let appObj = null
    switch (type) {
      case "officer":
        appObj = new PlasticsOfficer(this.user)
        break
      case "head":
        appObj = new PlasticsHead(this.user)
        break
      case "dg":
        appObj = new PlasticsDG(this.user)
      default:
        break
    }

    return appObj
  }

  getCompanies= (page)=>{
     const request = new Request({
      data: {
        url: "companies"+"?page="+page,
        token: "Bearer " + this.user.token,
      },
    })
    return this.getRequest(request)
  }

  getCompanyCompanies = (page,company_id)=>{
    const request = new Request({
      data: {
        url: "company/applications/"+company_id +"?page="+page,
        token: "Bearer " + this.user.token,
      },
    })
        return this.getRequest(request)
  }

}

export default CompanyService
